import "../digitalBanking.css";

import { useEffect, useState } from "react";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Deals from "sections/ComingSoon/Deals";
import InstallApp from "sections/ComingSoon/InstallApp";
import MyAlrajhiImportance from "sections/ComingSoon/MyAlrajhiImportance";
import Features from "sections/ComingSoon/Features";
import FeatureSpotlight from "sections/ComingSoon/FeatureSpotlight";
import GetMyalrajhi from "sections/ComingSoon/GetMyalrajhi";
import Promotions from "sections/ComingSoon/Promotions";
import LetsConnect from "sections/ComingSoon/LetsConnect";
import FAQs from "sections/ComingSoon/FAQs";
import GetStarted from "sections/ComingSoon/GetStarted";

function ComingSoon() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const fetchDealsFromCMS = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/coming-soons?sort=createdAt:desc&populate=*`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );
      setData(response.data.data[0]);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    fetchDealsFromCMS();
  }, []);
  return (
    <div id="coming-soon-main-container">
      {data?.deals && <Deals dealsData={data?.deals} />}
      <InstallApp />
      {data?.importance && <MyAlrajhiImportance data={data} />}
      {data?.features && <Features data={data} />}
      {/* {data?.featureSpotlight && <FeatureSpotlight data={data} />} */}
      {data?.getStarted && <GetStarted data={data} />}
      {data?.faqData && <FAQs data={data} />}
      <GetMyalrajhi />
      <Promotions />
      {data?.contactData && <LetsConnect data={data}/>}
    </div>
  );
}

export default ComingSoon;
